/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_TagInputs */

const en_gc_resources_guide_formulas_tag = /** @type {(inputs: Gc_Resources_Guide_Formulas_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulas`)
};

const zh_gc_resources_guide_formulas_tag = /** @type {(inputs: Gc_Resources_Guide_Formulas_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式`)
};

/**
* | output |
* | --- |
* | "Formulas" |
*
* @param {Gc_Resources_Guide_Formulas_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_tag = /** @type {((inputs?: Gc_Resources_Guide_Formulas_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_tag(inputs)
	return zh_gc_resources_guide_formulas_tag(inputs)
});
export { gc_resources_guide_formulas_tag as "gc.resources.guide.formulas.tag" }